<template>
  <div>
    <a-modal
      :afterClose="afterClose"
      :title="null"
      :closable="false"
      :footer="null"
      width="595px"
      v-model="fastBind1"
    >
      <a-spin :spinning="spinning">
        <div class="FastBind">
          <div class="title">
            <div class="name">- 快速绑定电子健康卡 -</div>
            <div class="card-big">
              <icon-font type="icon-jiankang" />
            </div>
          </div>
          <div class="content">
            <div class="form-box">
              <a-form-model
                ref="ruleForm"
                :rules="rules"
                :model="form"
                @submit="handleSubmit"
                @submit.native.prevent
              >
                <a-form-model-item class="idCard" prop="idCard">
                  <a-input
                    placeholder-style="font-size: 20px;"
                    v-model="form.idCard"
                    placeholder="请输入身份证号码"
                  >
                    <a-icon
                      slot="prefix"
                      type="user"
                      style="color:rgba(0,0,0,.25);font-size: 24px;"
                    />
                  </a-input>
                </a-form-model-item>
                <a-form-model-item>
                  <a-button
                    class="sure-box cursor-point hp_center"
                    type="primary"
                    html-type="submit"
                  >绑定</a-button>
                </a-form-model-item>
              </a-form-model>
            </div>
          </div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import { fastRecord } from "@/api/user-center";
import { filter } from "@/api/cardfilter";
export default {
  data() {
    let checkIdCard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入身份证号码"));
      }
      let zz = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/;
      if (!zz.test(value)) {
        callback(new Error("身份证号码格式错误"));
      } else {
        callback();
      }
    };
    return {
      form: {
        idCard: "",
        fromType: 5,
        queryType: 2,
      },
      rules: {
        idCard: [
          {
            validator: checkIdCard,
            trigger: "blur",
          },
        ],
      },
      fastBind1: false,
      spinning:false
    };
  },
  created() {},
  methods: {
    afterClose() {
      this.form = {
        idCard: "",
        fromType: 5,
        queryType: 2,
      };
    },
    handleSubmit() {
      let data = this.form
      // data.idCard = data.idCard.toLocaleUpperCase()
      if (!this.form.idCard) {
        this.$message.warning("身份证未填写");
        return;
      }
      if (filter(data)) {
        this.$refs["ruleForm"].validate(async (valid) => {
          if (valid) {
            this.spinning = true;

            var res = await fastRecord(this.form);
            this.spinning = false;
            if (res.code == 200) {
              this.$message.success("注册电子健康卡成功！");
            } else {
              this.$message.error(res.message);
            }
            this.$store
              .dispatch("setRelationRecords")
              .then(async () => {})
              .catch(() => {});
            this.onClose();
          }
        });
      } else {
        this.$message.warning("您已经注册过该身份证！,请勿重复注册");
        this.form.idCard = "";
      }
    },
    onClose() {
      this.fastBind1 = false;
    },
    onShow() {
      this.fastBind1 = true;
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.FastBind {
  width: 100%;
  .title {
    width: 100%;
    height: 140px;
    background: url("~@/assets/user-center/regester-card.png") no-repeat center
      center;
    background-size: 100% 100%;
    padding-top: 73px;
    position: relative;
    .name {
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      text-align: center;
    }
    .card-big {
      width: 105px;
      height: 105px;
      border-radius: 50%;
      border: 4px solid #fff;
      background: #1779ff;
      font-size: 50px;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: -52px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .content {
    padding: 25px;
    background: #fff;
    .sure-box {
      width: 100%;
      height: 78px;
      background: linear-gradient(90deg, #6fb2ff, #095fff);
      border-radius: 2px;
      letter-spacing: 10px;
      font-size: 31px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
    .fast-box {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #0f64ff;
      margin-top: 18px;
      margin-bottom: 45px;
    }
    .careful {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #999999;
    }
  }
}
.ant-form {
  width: 100%;
  .idCard {
    width: 100%;
    /deep/.ant-input {
      padding-left: 50px !important;
      font-size: 14px;
      height: 75px !important;
    }
  }
}
/deep/ .ant-modal-body {
  padding: 0;
}
</style>
